import React, { useState, useContext, useEffect } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
import { Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import { UserContext } from "../components/UserContext";
import CustomHelmet from "../components/CustomHelmet";

const url = "https://www.hubsquares.com/php_files/processLogin.php/";
const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [spin, setSpin] = useState(false);
  const user = useContext(UserContext);

  const handleSubmit = async (event) => {
    setSpin(true);
    event.preventDefault();
    await axios
      .post(url, {
        username: username,
        password: password,
      })
      .then(({ data }) => {
        if (data.success === 1) {
          setSpin(true);
          user.setUser(localStorage.getItem("access_token") || data.session);
          localStorage.setItem("access_token", data.session);
          props.history.push("/dashboard");
        }
        // props.history.push(`/`);
        else if (data.success === 0) {
          setSpin(false);
          setErrorValue(data.msg);
          setError(true);
        }
      });
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error]);
  return (
    <div>
      <CustomHelmet page="Login" />
      <div className="wrapper login_banner position-relative">
        <div className="overlay">
          <Navbar />

          <div className="banner">
            <div className=" text-center mt-6 container">
              <div className="row">
                <div className="col-3"></div>
                <div className="col-md-6 col-sm-12">
                  <h1 className="mb-3">Login</h1>
                  {error && (
                    <Fade bottom collapse when={error}>
                      <Alert variant="danger">{errorValue}</Alert>
                    </Fade>
                  )}
                  <p>Enter you credentials to continue</p>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                      <div className="input-group">
                        <i className="fal fa-user-circle position-absolute icon-l "></i>
                      </div>
                      <input
                        type="text"
                        className="form-control pl-5 input-pad form-control-lg"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <div className="input-group">
                        <i
                          className="fa fa-lock position-absolute icon-l"
                          aria-hidden="true"
                        ></i>
                      </div>
                      <input
                        type="password"
                        className="form-control pl-5 input-pad form-control-lg"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center login-sec">
                      <button
                        type="submit"
                        disabled={spin}
                        className="btn border-0 auth-btn py-2 px-5 btn-danger btn-lg rad-0 addbtn"
                      >
                        Login
                        {spin && (
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                      <p className="my-auto">
                        <Link to="/register" className="text-white">
                          New user?
                        </Link>{" "}
                        |{" "}
                        <Link to="/reset-password" className="text-white">
                          {" "}
                          Reset Password
                        </Link>
                      </p>
                    </div>
                    {/* </div> */}
                  </form>
                </div>
                <div className="col-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer style={{ marginTop: "0" }} />
    </div>
  );
};
export default Login;
